import { lazy } from 'react';

const Account = lazy(() => import('./Account'));

export default Account;
